module.exports = __webpack_public_path__ + "img/add-posi.834f440e.png";